"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeCartsClient = void 0;
const CartsFactory_1 = require("../../../test-support/CartsFactory");
class FakeCartsClient {
    constructor() {
        this.cart = this.getEmptyCart();
        this.generateItemId = () => {
            return (this.cart.items.length + 1).toString();
        };
    }
    getCart() {
        return Promise.resolve(this.cart);
    }
    insertCartItem(cartItem) {
        this.cart.items.push(CartsFactory_1.CartItemFactory.sample({
            ...cartItem,
        }));
    }
    addItemToCart(_, videoId) {
        const cartItem = CartsFactory_1.CartItemFactory.sample({
            id: this.generateItemId(),
            videoId,
        });
        this.cart.items.push(cartItem);
        return Promise.resolve(cartItem);
    }
    async updateCart(note) {
        this.cart.note = note;
        return Promise.resolve(this.cart);
    }
    deleteItemFromCart(_, cartItemId) {
        const cartItemIds = this.cart.items.map((it) => it.id);
        const cartItemIndex = cartItemIds.indexOf(cartItemId);
        this.cart.items.splice(cartItemIndex, 1);
        return Promise.resolve();
    }
    updateCartItemAdditionalServices(cartItem, additionalServices) {
        const itemToUpdate = this.cart.items.find((item) => item.id === cartItem.id);
        if (itemToUpdate) {
            itemToUpdate.additionalServices = additionalServices;
        }
        return Promise.resolve(this.cart);
    }
    clear() {
        this.cart = this.getEmptyCart();
    }
    getEmptyCart() {
        return CartsFactory_1.CartsFactory.sample({ items: [], note: undefined });
    }
}
exports.FakeCartsClient = FakeCartsClient;
//# sourceMappingURL=FakeCartsClient.js.map